import styled from 'styled-components';
const Background = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: var(--tintColor);
  height: 100%;
  width: 100%;

  &[data-close='true'] {
    cursor: zoom-out;
  }
`;
const BackgroundStyles = {
    Background,
};
export default BackgroundStyles;
